import {IconButton, Stack, SxProps, Theme} from "@mui/material";
import {LogoutIcon, SettingsIcon} from "../icons";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "@core/store";
import {clearApp, setSettingsOpen} from "@core/store/slices/appSlice";
import {Settings} from "./settings";
import {LogoutDialog} from "./LogoutDialog";
import {useState} from "react";
import {logout} from "@core/store/slices/authSlice";
import {api} from "@core/api";
import {Notifications} from "@components/notifications";
import {useDownBreakpoint} from "@hooks";
import {AdvancedSearch} from "@components";
import {UserAction} from "./user";

const UserActions = ({
  sx,
  size = "small",
}: {
  sx?: SxProps<Theme>;
  size?: "small" | "medium" | "large";
  onPrimary?: boolean;
}) => {
  const dispatch = useDispatch();

  const settingsOpen = useSelector(
    (state: RootState) => state.app.settingsOpen,
  );

  const [logoutDialogOpen, setLogoutDialogOpen] = useState<boolean>(false);

  const [logoutMutation, {isLoading: isLoggingOut}] = api.useLogoutMutation();

  const handleLogout = async () => {
    try {
      await logoutMutation().unwrap();
    } catch {
      // Se l'API fallisce comunque facciamo il logout locale
    } finally {
      // Effettua il logout locale indipendentemente dal risultato dell'API
      dispatch(logout());
      dispatch(clearApp());
      dispatch(api.util.resetApiState());
      setLogoutDialogOpen(false);
    }
  };

  const isDownLg = useDownBreakpoint("lg");

  if (isDownLg) {
    return (
      <Stack direction="row" gap={1} alignItems="center" sx={sx}>
        <AdvancedSearch />
        <Notifications size={size} />
        <UserAction />
        <Settings
          open={settingsOpen}
          onClose={() => dispatch(setSettingsOpen(false))}
        />
        <LogoutDialog
          onConfirm={handleLogout}
          onCancel={() => setLogoutDialogOpen(false)}
          open={logoutDialogOpen}
          loading={isLoggingOut}
        />
      </Stack>
    );
  } else {
    return (
      <Stack direction="row" gap={1} alignItems="center" sx={sx}>
        <AdvancedSearch />
        <Notifications size={size} />
        <IconButton onClick={() => dispatch(setSettingsOpen(true))} size={size}>
          <SettingsIcon fontSize="inherit" color="action" />
        </IconButton>
        <IconButton onClick={() => setLogoutDialogOpen(true)} size={size}>
          <LogoutIcon fontSize="inherit" color="action" />
        </IconButton>
        <Settings
          open={settingsOpen}
          onClose={() => dispatch(setSettingsOpen(false))}
        />
        <UserAction />

        <LogoutDialog
          onConfirm={handleLogout}
          onCancel={() => setLogoutDialogOpen(false)}
          open={logoutDialogOpen}
          loading={isLoggingOut}
        />
      </Stack>
    );
  }
};

export {UserActions};
